import { ThemeButton } from '@coorum-research/core/src/components/ThemeButton'
import { useState } from 'react'

type Props = {
  images: string[]
  onSubmit: (selectedImage: string | null) => void
}

export function ThumbnailSelector({ images, onSubmit }: Props) {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null)
  const isDisabled = selectedImageIndex === null

  const handleImageSelect = (index: number) => {
    setSelectedImageIndex(index)
  }

  const handleSubmitClick = () => {
    if (selectedImageIndex === null) {
      console.error('No image selected')
      return
    }
    onSubmit(images[selectedImageIndex])
  }

  return (
    <div className="mx-6 h-full overflow-y-auto">
      <p className="font-bold">投稿のサムネイルに使う画像を選択</p>
      <div className="mt-4 flex flex-col">
        {images.length > 0
          ? (
            images.map((image, index) => (
            <label key={image} className="flex items-center gap-4">
              <input
                type="radio"
                name="thumbnail"
                checked={selectedImageIndex === index}
                onChange={() => handleImageSelect(index)}
                className="hidden"
              />
              <img
                src={image}
                alt={`Thumbnail option ${index + 1}`}
                className={`mb-4 max-h-[160px] w-full cursor-pointer rounded object-cover ${
                  selectedImageIndex === index ? 'border-[3px] border-blue-500' : ''
                }`}
              />
            </label>
          ))
        )
        : (
          <p>画像がありません</p>
        )}
      </div>
      <ThemeButton
        className={`my-4 font-semibold ${isDisabled ? 'border-0 bg-[#E4E4E4] opacity-40' : ''}`}
        onClick={handleSubmitClick}
        disabled={isDisabled}
      >
        投稿
      </ThemeButton>
    </div>
  )
}
